var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { bulletinboardsApi } from 'apis/bulletinboards';
import { useAppSelector } from 'utils/redux/useAppSelector';
export function useAddBoardIdIfNeeded(API, messengerId) {
    const [createBoard] = bulletinboardsApi.useCreateBulletinBoardMutation();
    const organizationId = useAppSelector((state) => state.settings.organization.organization.id);
    const hasBulletinBoardSetup = (messengerSettings) => {
        var _a, _b, _c;
        return Boolean((_c = (_b = (_a = messengerSettings === null || messengerSettings === void 0 ? void 0 : messengerSettings.settings) === null || _a === void 0 ? void 0 : _a.integrations) === null || _b === void 0 ? void 0 : _b.bulletinBoard) === null || _c === void 0 ? void 0 : _c.boardId);
    };
    // Can throw error, so make sure you handle it
    const createBoardIfNeeded = useCallback((messenger) => __awaiter(this, void 0, void 0, function* () {
        if (!messengerId || hasBulletinBoardSetup(messenger)) {
            return messenger;
        }
        const boardRes = yield createBoard({ organizationId });
        if (!('data' in boardRes)) {
            return messenger;
        }
        const response = yield API.patchSettings(messengerId, {
            integrations: {
                bulletinBoard: {
                    boardId: boardRes.data.id,
                    enabled: false,
                },
            },
        });
        return response;
    }), [messengerId, organizationId, createBoard, API]);
    return createBoardIfNeeded;
}
